/**
 * Created by r4zi4l on 04.05.2022
 */

const Offer = function (offerType, savedData) { 
    const data = Offers[offerType];

    this.type = data.type;
    this.force = data.force;

    const LogicCtor = data.logic ? data.logic : OfferLogic;
    this.logic = new LogicCtor(this);

    this.name = data.name;
    this.bundle = data.bundle;
    this.visual = data.visual;
    this.restartable = data.restartable;
    this.tileShopPriority = data.tileShopPriority;

    this.load(savedData);
    if (!this.started) {
        this.fresh = true;
        this.started = Date.now();
        delete this.finished;
    }

    this.sideBarJson = Array.isArray(data.sideBarJson) ? data.sideBarJson[this.stage || 0] : data.sideBarJson;
    this.extraBarIcon = Array.isArray(data.extraBarIcon) ? data.extraBarIcon[this.stage || 0] : data.extraBarIcon;

    if (!savedData && data.force) {
        cleverapps.forces.clearForce(data.force);
    }

    this.onUpdateState();
};

Offer.prototype.load = function (data) {
    if (!data) {
        return;
    }

    this.started = data.started;
    this.finished = data.finished;
    this.stage = data.stage;
    this.lastRewardTime = data.lastRewardTime;
};

Offer.prototype.getInfo = function () {
    return {
        started: this.started,
        finished: this.finished,
        lastRewardTime: this.lastRewardTime,
        stage: this.stage
    };
};

Offer.prototype.refresh = function () {
    if (this.logic.refresh) {
        this.logic.refresh();
    }
};

Offer.prototype.reset = function () {
    const product = this.logic.getProduct();
    if (product) {
        product.saveVideoProgress(0);
    }
};

Offer.prototype.incStage = function () {
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.OFFER_STAGE}_${this.stage || 0}`, { itemId: this.name });

    this.stage = (this.stage || 0) + 1;

    cleverapps.offerManager.save();
    cleverapps.offerManager.refreshOffer(this.type);
};

Offer.prototype.onUpdateState = function () {
    if (this.countdown) {
        this.countdown.remove();
        delete this.countdown;
    }

    const leftTime = this.logic.getTimeLeft();
    if (leftTime > 0) {
        this.countdown = new cleverapps.CountDown(leftTime, {
            onFinish: this.checkCompletion.bind(this),
            permanent: true
        });
    }
};

Offer.prototype.checkCompletion = function () {
    if (this.checkLeftTime() && !(this.logic.needWait && this.logic.needWait())) {
        if (this.restartable) {
            this.started = Date.now();
        } else {
            this.complete();
        }
    }

    if (this.logic.checkIfComplete) {
        this.logic.checkIfComplete();
    }
};

Offer.prototype.checkLeftTime = function () {
    const duration = Offers[this.type].duration;
    return duration && this.started && Date.now() > this.started + cleverapps.parseInterval(duration);
};

Offer.prototype.complete = function () {
    if (!Offers[this.type].availableByStages) {
        delete this.stage;
    }
    const duration = Offers[this.type].duration;

    this.finished = Date.now();

    if (duration) {
        this.finished = Math.min(this.finished, this.started + cleverapps.parseInterval(duration));
    }

    delete this.started;

    cleverapps.offerManager.save();

    cleverapps.offerManager.refreshOffer(this.type);
};

Offer.prototype.beforeRemove = function () {
    if (this.countdown) {
        this.countdown.remove();
        delete this.countdown;
    }
};

Offer.prototype.logPurchase = function (product) {
    Offer.LogPurchase(this, product);
};

Offer.LogPurchase = function (offer, product) {
    const params = { itemId: offer.name, productId: product.itemId };

    if (offer.logic && offer.logic.getPurchaseParams) {
        Object.assign(params, offer.logic.getPurchaseParams());
    }

    cleverapps.metrics.logEvent(cleverapps.EVENTS.OFFER_BUY, params);

    if (Offers[offer.type].inABExperiments) {
        cleverapps.abExperiments.allLogEvent(cleverapps.EVENTS.OFFER_BUY, params);
    }
};